import React, { useState, useEffect } from "react";
import "./organigrama.css";
import data from "../../json/ciorganigramaitems";

const Organigrama = () => {

  const [expandida, setExpandida] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleImagen = (id) => {
    setExpandida(expandida === id ? null : id);
  };

  return (
    
    
    <div
  className="container-full-width cinterno-bg"
  style={{
    backgroundImage: `url(${data.background})`,
    backgroundSize: "30%",        // Hace que la imagen cubra 30% del contenedor
    backgroundPosition: "center",   // Centra la imagen
    backgroundRepeat: "repeat",  // imagen en mosaico
    width: "100%",
    minHeight: "100vh"              // Ocupa toda la altura de la pantalla
  }}
>

      {/* ================================================= */}
      {/* 1️⃣ ENCABEZADO */}
      {/* ================================================= */}
      <h3 className="title">
        Organigrama
      </h3>
      <hr className='hr-gob' />

      {/* ================================================= */}
      {/* 2️⃣ BARRA CON ENLACES */}
      {/* ================================================= */}
      <div className="subheader-links">
        {data.links?.map((link, index) => (
          <a key={index} href={link.url} className="link-custom">
            {link.texto}
          </a>
        ))}
      </div>

      {/* ================================================= */}
      {/* 3️⃣ CUADRO DE TEXTO */}
      {/* ================================================= */}
      <div className="cuadro-texto">
        <h4>{data.cuadroTexto?.titulo}</h4><br />
        <p
  dangerouslySetInnerHTML={{
    __html: data.cuadroTexto.descripcion
  }}
></p>
      </div>

      {/* ================================================= */}
      {/* 4️⃣ IMÁGENES EXPANDIBLES */}
      {/* ================================================= */}
      <div className="hero">

        {data.imagenes?.map((img) => (
          <div className="contenedor" key={img.id}>
            <img
              src={img.src}
              alt="contenido"
              className={
                expandida === img.id
                  ? "img expandida"
                  : "img"
              }
              onClick={() => toggleImagen(img.id)}
            />
          </div>
        ))}

      </div>

      {/* ================================================= */}
      {/* 5️⃣ PDF VIEWER */}
      {/* ================================================= */}
      <div className="pdf-viewer">
        <iframe
          src={data.pdfViewer}
          title="PDF Viewer"
          width="100%"
          height="600px"
        />
      </div>

    </div>
  );
};

export default Organigrama;